import { cloneDeep } from 'lodash';
import * as React from 'react';

import { IBranding, IDocument, IUserData } from '../../../../infrastructure/interfaces';
import BrandingEditorForm from '../../../DocumentEditor/BrandingEditorForm';
import SettingsNav from './SettingsNav';

export interface IBrandingEditorProps {
  document: IDocument;
  brandings: IBranding[];
  userData: IUserData;
  saveDocument(document: IDocument, userID: string, redirect?: string): void;
  updateModelDocument(document: IDocument): void;
  cancelDocument(): void;
}

export interface IBrandingEditorState {
  document: IDocument;
}


export default class BrandingEditor extends React.Component<IBrandingEditorProps, IBrandingEditorState> {
  constructor(props: IBrandingEditorProps) {
    super(props);
    this.state = {
      document: cloneDeep(props.document),
    };
  }

  componentWillUnmount() {
    if (this.props.updateModelDocument) {
      this.props.updateModelDocument(this.state.document);
    }
  }

  componentWillReceiveProps(nextProps: IBrandingEditorProps) {
    if (nextProps.document !== this.props.document) {
      this.setState({ document: cloneDeep(nextProps.document) });
    }
  }

  onBrandChange = (branding: IBranding) => {
    this.setState({
      document: {
        ...this.state.document,
        branding,
      },
    });
  }

  cancel = () => {
    this.setState({ document: cloneDeep(this.props.document) });
    if (this.props.cancelDocument) {
      this.props.cancelDocument();
    }
  }

  onSave = () => {
    this.props.saveDocument(this.state.document, this.props.userData.id);
  }

  render() {
    return (
      <div className="cropsEditorContainer">
        <SettingsNav
          cancel={this.cancel}
          document={this.state.document}
          onSave={this.onSave}
        />
        <div className="">
          <div className="cropsContainerTitle">
            Front Cover Branding
          </div>
          <div className="cropsContainerWarning">
            "Does not apply to Seed Quad Fold Covers"
          </div>
        </div>
        <BrandingEditorForm
          document={this.state.document}
          brandings={this.props.brandings}
          onBrandChange={this.onBrandChange}
          className="settingsCropsListContainer settingsCropsListContainer--logo"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/BrandingEditor.tsx